import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginatedResult, BusinessSetting, CreateUpdateBusinessSettingDto } from 'app/models/business-setting';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessSettingService {

  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api";
  }

  constructor(private http: HttpClient) {}

  private getHeaders(language: string = 'en'): HttpHeaders {
    return new HttpHeaders({
      'App-Language': language
    });
  }

  // GET: Paginated List
  getBusinessSettings(pageNumber: number = 1, pageSize: number = 10, language: string = 'en'): Observable<PaginatedResult<BusinessSetting>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<PaginatedResult<BusinessSetting>>(`${this.apiUrl}/BusinessSettings`, {
      headers: this.getHeaders(language),
      params
    });
  }

  // GET: Single Item by ID
  getBusinessSetting(id: number, language: string = 'en'): Observable<BusinessSetting> {
    return this.http.get<BusinessSetting>(`${this.apiUrl}/BusinessSettings/${id}`, {
      headers: this.getHeaders(language)
    });
  }

  // POST: Create
  createBusinessSetting(payload: CreateUpdateBusinessSettingDto, language: string = 'en'): Observable<BusinessSetting> {
    return this.http.post<BusinessSetting>(`${this.apiUrl}/BusinessSettings`, payload, {
      headers: this.getHeaders(language)
    });
  }

  // PUT: Update
  updateBusinessSetting(id: number, payload: CreateUpdateBusinessSettingDto, language: string = 'en'): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/BusinessSettings/${id}`, payload, {
      headers: this.getHeaders(language)
    });
  }

  // DELETE: Remove
  deleteBusinessSetting(id: number, language: string = 'en'): Observable<any> {
    return this.http.delete(`${this.apiUrl}/BusinessSettings/${id}`, {
      headers: this.getHeaders(language)
    });
  }
}